import { Miniature } from '../../../models/miniature';

export const DigitalMiniature: Miniature = {
    type: 'Digital',
    title: 'Digital tag',
    icon: 'fa-list-ol',
    highlights: ['A new digital tag'],
    create: () => { },
    group: '',
    sortingOrder: 10
};